/* This file is autogenerated, see readme.md for instructions */
import ChevronLeftFillSvgIcon from '@bloomreach/banana-theme/icons/chevron-left-fill.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ChevronLeftFillIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ChevronLeftFillSvgIcon />
    </Icon>
  );
});

ChevronLeftFillIcon.displayName = 'ChevronLeftFillIcon';

export default ChevronLeftFillIcon;
